/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Resilience_Stress_Tolerance25Inputs */

const en_job_form_enum_resilience_stress_tolerance25 = /** @type {(inputs: Job_Form_Enum_Resilience_Stress_Tolerance25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resilience and Stress Tolerance`)
};

const de_job_form_enum_resilience_stress_tolerance25 = /** @type {(inputs: Job_Form_Enum_Resilience_Stress_Tolerance25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belastbarkeit und Stresstoleranz`)
};

/**
* | output |
* | --- |
* | "Resilience and Stress Tolerance" |
*
* @param {Job_Form_Enum_Resilience_Stress_Tolerance25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_resilience_stress_tolerance25 = /** @type {((inputs?: Job_Form_Enum_Resilience_Stress_Tolerance25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Resilience_Stress_Tolerance25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_resilience_stress_tolerance25(inputs)
	return en_job_form_enum_resilience_stress_tolerance25(inputs)
});
export { job_form_enum_resilience_stress_tolerance25 as "job_form_enum_RESILIENCE_STRESS_TOLERANCE" }